import { Component } from '@angular/core';
import { ENPOINT } from './../../services/endpoint';

@Component({
  selector: 'app-manuals',
  templateUrl: './manuals.component.html',
  styleUrls: ['./manuals.component.scss']
})
export class ManualsComponent {
  basePath;
  page: number = 1;
  totalPages: number;
  isLoaded: boolean = false;
  zoom_to = 0.8;
  urlPdf;

  constructor(
  ) {
    this.basePath = ENPOINT.urlBase;
    this.urlPdf = this.basePath + 'docs/manuales/guiaRapida.pdf'; 
  }

  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
  }

  nextPage() {
    this.page++;
  }

  prevPage() {
    this.page--;
  }

  zoom_in() {
    if (this.zoom_to <= 1) {
      this.zoom_to = this.zoom_to + 0.25;
    }
  }

  zoom_out() {
    if (this.zoom_to > 1) {
      this.zoom_to = this.zoom_to - 0.25;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/manuals/manuals.component.ts